import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/utils";
import { CheckMark, Fig, FigProps, LAB } from "@/components/ms";

/**
 * The two things the ms kit leaves to the caller: a Fig row that is a real
 * anchor (so cmd-click still works) and a DHead action that navigates.
 */

/** Fig row wrapped in a Link. The hairline moves to the anchor so `first:` still hits. */
export const FigLink = ({
  to,
  className,
  ...fig
}: FigProps & { to: string }) => (
  <Link
    to={to}
    className="block border-t border-ms-line transition-colors first:border-t-0 hover:bg-ms-card2"
  >
    <Fig {...fig} className={cn("min-h-[44px] border-t-0", className)} />
  </Link>
);

/** The green "See all →" that sits on the right of a DHead. */
export const HeadLink = ({
  to,
  children,
  className,
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
}) => (
  <Link
    to={to}
    className={cn(
      LAB,
      "text-[9.5px] text-ms-link transition-colors hover:text-ms-ink",
      className
    )}
  >
    {children} →
  </Link>
);

/** The tick / live dot / empty circle that leads a checklist or filing step. */
export const StepMark = ({ state }: { state: "done" | "live" | "wait" }) => {
  if (state === "done") {
    return (
      <span className="grid h-[18px] w-[18px] place-items-center rounded-full bg-ms-mint-soft text-ms-link">
        <CheckMark size={10} />
      </span>
    );
  }
  if (state === "live") {
    return (
      <span className="grid h-[18px] w-[18px] place-items-center rounded-full border border-ms-rule">
        <span className="h-[6px] w-[6px] rounded-full bg-ms-rule" />
      </span>
    );
  }
  return <span className="block h-[18px] w-[18px] rounded-full border border-ms-line2" />;
};
